import type { Book } from './bookTypes'

export type { Book } from './bookTypes'

export const bookData: Book[] = [
  {
    id: 'glp1-nutrition-guide',
    title: 'The GLP-1 Nutrition Guide',
    subtitle: 'Structured Nutrition for Sustainable Results',
    description:
      'A 40+ page comprehensive framework for navigating GLP-1 medications. Protect muscle mass, manage side effects, and build habits that outlast the prescription.',
    pages: '40+ pages',
    status: 'available',
    coverVariant: 'charcoal',
    badge: 'Bestseller',
    // Test Stripe price wired here for end-to-end checkout testing
    stripePriceId: 'price_1TVXINQUGJBy0bOki9RZIHW',
    priceCents: 100,
  },
  {
    id: 'protein-playbook',
    title: 'The Protein Playbook',
    subtitle: 'Hit Your Targets at Every Stage of Life',
    description:
      'A practical guide to optimizing protein intake for muscle preservation, body composition, and metabolic health.',
    pages: 'Coming 2026',
    status: 'coming-soon',
    coverVariant: 'burgundy',
  },
  {
    id: 'metabolic-reset',
    title: 'The Metabolic Reset',
    subtitle: 'Transitioning Off Weight Loss Medications',
    description:
      'A step-down protocol for maintaining results when stepping down or stopping GLP-1 therapy.',
    pages: 'Coming 2026',
    status: 'coming-soon',
    coverVariant: 'navyslate',
  },
]
